<template>
  <div>
    <form class="z-2" @submit.prevent="saveMasterclass">
      <div class="bg-beige-academy-300 text-white px-5 lg:px-10 flex justify-center items-center">
        <h4 class="font-medium text-base lg:text-xl uppercase w-full flex
        justify-center">
          {{ $t('masterclass.add') }}</h4>
        <div class="my-5">
          <modal-button :buttonPlaceholder="$t('slotsCreation.save')"
            buttonClass="uppercase" />
        </div>
      </div>
      <div class="mx-10 my-12 text-xs">
        <div class="flex flex-col justify-start mb-6 uppercase font-sans-serif">
          {{ $t('masterclass.addTitle') }}
          <input v-model="newMasterclass.title"
            class="outline-none border border-beige-academy-500 mt-3 p-1 rounded"
            @input="errors.title = ''" />
          <div v-if="errors.title" class="text-red-500">
            {{ errors.title }}
          </div>
        </div>
        <div class="flex flex-col justify-start mb-4 font-sans-serif uppercase w-full">
          {{ $t('masterclass.description') }}
          <textarea v-model="newMasterclass.description"
            class="outline-none border border-beige-academy-500 mt-3 p-1 rounded"
            @input="errors.description = ''" />
          <div v-if="errors.description" class="text-red-500">
            {{ errors.description }}
          </div>
        </div>
        <div class="flex flex-col justify-between items-start mb-6 font-sans-serif uppercase" >
          <div class="flex justify-between items-center w-full md:w-1/2">
             {{ $t('masterclass.day') }}:
            <div class="border border-beige-academy-500 p-1 w-3/4 md:w-2/3 rounded">
              <datetime
                :min-datetime="minDatetime"
                v-model="newMasterclass.day"
                :zone="timezone"
                :value-zone="timezone"
                type="date"
                class="h-1/3 mx-2 w-full"
                @input="errors.day = ''" />
            </div>
          </div>
          <div v-if="errors.day" class="text-red-500">
            {{ errors.day }}
          </div>
        </div>

        <div class="flex flex-col md:flex-row w-full">
          <div class="flex flex-col w-full md:w-1/2 mb-2 uppercase font-sans-serif">
            <div class="flex justify-start w-full items-center">
              {{ $t('slotsCreation.startHour') }}:
              <datetime
                type="time"
                class="border border-beige-academy-500 p-1 w-full md:w-2/3 ml-4 rounded"
                v-model="newMasterclass.start"
                :minute-step="minuteStep"
                :zone="timezone"
                :value-zone="timezone"
                placeholder="Select time"
                @input="errors.start = ''" />
            </div>
            <div v-if="errors.start" class="text-red-500">
              {{ errors.start }}
            </div>
          </div>

          <div class="flex flex-col w-full md:w-1/2 mb-2 uppercase font-sans-serif ml-2">
            <div class="flex justify-start w-full items-center">
              {{ $t('slotsCreation.endHour') }}:
              <datetime
                type="time"
                class="border border-beige-academy-500 p-1 w-2/3 rounded ml-4"
                v-model="newMasterclass.end"
                :minute-step="minuteStep"
                :zone="timezone"
                :value-zone="timezone"
                placeholder="Select time"
                @input="errors.end = ''" />
            </div>
            <div v-if="errors.end" class="text-red-500">
              {{ errors.end }}
            </div>
          </div>
        </div>

        <div class="font-sans-serif flex justify-between mb-6 w-full mt-3 items-center">
          <span class="w-auto uppercase mr-2">{{ $t('masterclass.max') }}</span>
          <input v-model="newMasterclass.participants" type="number" placeholder="unlimited"
            class="outline-none border border-beige-academy-500 w-4/5 p-1 rounded" />
        </div>
      </div>

    </form>

  </div>
</template>

<style scoped>
  @import 'https://unpkg.com/vue-datetime/dist/vue-datetime.css';
</style>

<script>
// import { MDCCheckbox } from '@material/checkbox';
// import { MDCFormField } from '@material/form-field';
import axios from 'axios';
import { Datetime } from 'vue-datetime';
import { mapActions, mapGetters } from 'vuex';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import DatesConversion from '@/mixins/DatesConversion';
import dayjs from 'dayjs';
import ModalButton from '../graphics/ModalButton.vue';

/* const checkbox = new MDCCheckbox(document.querySelector('.mdc-checkbox'));
const formField = new MDCFormField(document.querySelector('.mdc-form-field'));
formField.input = checkbox; */

export default {
  data() {
    return {
      slots: [],

      newMasterclass: {
        title: '',
        day: null,
        start: null,
        end: null,
        description: '',
        participants: null,
      },

      price: null,

      minuteStep: 15,
      isLogged: true,
      minDatetime: dayjs.tz().toISOString(),

      errors: {
        title: '',
        day: '',
        start: '',
        end: '',
        description: '',
        participants: '',
      },
    };
  },

  mixins: [StreamFunctionsMixin, DatesConversion],

  computed: {
    ...mapGetters({
      timezone: 'timezone/choosenTimezone',
    }),

    mDay() {
      return dayjs(this.newMasterclass.day);
    },

    mHourStart() {
      return dayjs(this.newMasterclass.start);
    },

    mHourEnd() {
      return dayjs(this.newMasterclass.end);
    },
  },

  props: {
    id: Number,
    savedSlots: Array,
  },

  components: {
    datetime: Datetime,
    ModalButton,
  },

  methods: {
    getDate(time) {
      const dayExtracted = this.newMasterclass.day.split('T')[0];
      const timeExtracted = time.split('T')[1];

      return this.changeDateFormatForCalendarAndDatabase(this.convertDateTimezoneForDatabase(`${dayExtracted}T${timeExtracted}`));
    },

    saveMasterclass() {
      if (this.dataIsOk()) {
        const masterclass = {
          title: this.newMasterclass.title,
          description: this.newMasterclass.description,
          day: this.getDate(this.newMasterclass.day),
          start: this.getDate(this.newMasterclass.start),
          end: this.getDate(this.newMasterclass.end),
          participants: this.newMasterclass.participants,
        };

        axios.post(`/api/teachers/${this.id}/masterclass`, masterclass)
          .then(() => {
            this.createNotification('success', this.$t('masterclass.success'));
            this.updatedSlots(true);
            this.$emit('close');
          })
          .catch(() => {
            this.createNotification('error', this.$t('notifications.errorTryAgain'));
          });
      }
    },

    ...mapActions({
      updatedSlots: 'slots/updatedSlots',
    }),

    dataIsOk() {
      let ok = true;
      Object.keys(this.newMasterclass).forEach((key) => {
        if (!this.newMasterclass[key] && key !== 'participants') {
          this.errors[key] = this.$t('fill-in');
          ok = false;
        }
      });

      return ok;
    },

  },

};
</script>
